import React, { useEffect, useState } from 'react';
export function CountdownBar() {
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes in seconds
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="bg-white w-full py-2 px-4 text-center shadow-sm sticky top-0 z-50 border-b border-gray-100" data-id="element-48">
      <p className="text-[#1E3A8A] font-bold text-sm md:text-base flex items-center justify-center gap-2 flex-wrap" data-id="element-49">
        <span data-id="element-50">🔥</span>
        <span data-id="element-51">OFERTA POR TIEMPO LIMITADO</span>
        <span data-id="element-52">🔥</span>
        <span className="inline-flex items-center gap-1 bg-[#F97316] text-white font-mono font-extrabold text-base md:text-lg px-3 py-1 rounded-md ml-2 tabular-nums tracking-wider" data-id="element-53">
          {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
        </span>
      </p>
    </div>;
}